import { AppContext } from 'contexts/AppContext'
import { Rocket } from 'components/Icons/rocket'
import { useContext, useEffect, useState } from 'react'
import { webisodeService } from 'api/services/webisodes'
import { Webisode } from 'api/types/webisode'
import { deltaToHtmlQuill } from 'utils/quillToHtml'
import { AuthContext } from 'contexts/AuthContext'
import { RocketPrime } from 'components/Icons/rocketPrime'

export const Webisodes = () => {
  const { currentBroker } = useContext(AuthContext)
  const { settings } = useContext(AppContext)
  const [webisode, setWebisode] = useState<Webisode | null>(null)

  const getWebisodeDetails = async () => {
    if (!settings || !settings.dashboardWebisode) return

    try {
      const response = (await webisodeService.getWebisode({
        id: settings.dashboardWebisode,
      })) as Webisode
      setWebisode(response as Webisode)

      if (!response?.content) return
      const html = deltaToHtmlQuill(response.content)
      setWebisode(prev => ({ ...prev, content: html }) as Webisode)
    } catch (error) {
      console.error('Failed to get webisode details', error)
    }
  }

  useEffect(() => {
    getWebisodeDetails()
  }, [settings])

  if (!webisode) return null

  return (
    <div className="p-4 bg-white h-full">
      <div className="flex items-start gap-1">
        <div className="flex items-center flex-col gap-1 pt-3">
          {currentBroker?.IsPrimePartner ? <RocketPrime /> : <Rocket />}
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 items-end">
          <div>
            <h2 className="text-body-1 uppercase pb-2">WEBISODES</h2>
            <h3
              className={`text-body-3 font-bold ${currentBroker?.IsPrimePartner ? 'text-prime' : 'text-primary'} pb-1`}
            >
              {webisode.title}
            </h3>
            <div
              className="text-body-4 text-metal-600 font-medium"
              dangerouslySetInnerHTML={{ __html: webisode.content || '' }}
            ></div>
            {webisode.link && (
              <a
                href={`https://www.youtube.com/watch?v=${webisode.link}`}
                target="_blank"
                rel="noopener noreferrer"
                className={`underline text-body-4 font-medium ${currentBroker?.IsPrimePartner ? 'text-prime' : 'text-primary'}`}
              >
                {webisode.label}
              </a>
            )}
          </div>
          <img
            className="w-full h-auto max-h-[260px] block object-cover object-center rounded-xl"
            src={`https://img.youtube.com/vi/${webisode.link}/maxresdefault.jpg`}
            alt={webisode.title}
          />
        </div>
      </div>
    </div>
  )
}
